import { render, staticRenderFns } from "./StrBirimGosterge.vue?vue&type=template&id=24beaa84"
import script from "./StrBirimGosterge.vue?vue&type=script&lang=js"
export * from "./StrBirimGosterge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports